import { Auth0Provider } from "@auth0/auth0-react";
import { isBrave, isIOS, isSafari } from "@stadium/helpers";

import { onRedirectCallback } from "./utils";

export const AuthServiceProvider = ({
  children,
  brand,
  clientId,
  audience,
  dbConnection,
  domain,
}) => (
  <Auth0Provider
    audience={audience}
    brand={brand}
    clientId={clientId}
    dbConnection={dbConnection}
    domain={domain}
    scope="read:current_user"
    redirectUri={typeof window === "object" && window.location.origin}
    onRedirectCallback={onRedirectCallback}
    cacheLocation={isSafari() || isIOS() || isBrave() ? "localstorage" : "memory"}
    useRefreshTokens
  >
    {children}
  </Auth0Provider>
);
